import { DatePicker, Input, Form, Select, Radio } from "antd";
import { TableAPI } from "../../API/TableAPI";
import React from "react";
import moment from "moment";
import { FormInstance } from "antd/lib/form";
import makeEntryModal from "./CreateEntryModals";
import Entry from "../../Model/Entry";

function renderForm(form: FormInstance) {
  return (
    <Form className="modal-form" hideRequiredMark={true} form={form}>
      <Form.Item
        name="name"
        label="Name"
        rules={[{ required: true, message: "Name is required" }]}
      >
        <Input />
      </Form.Item>

      <Form.Item name="runType" label="Active/Passive" required>
        <Select>
          <Select.Option value="Operational">Operational</Select.Option>
          <Select.Option value="Hindcast">Hindcast</Select.Option>
          <Select.Option value="Hindcast">Reanalysis</Select.Option>
        </Select>
      </Form.Item>

      <Form.Item name="dataAvailabilityFrom" label="Data Availability from">
        <DatePicker format="YYYY-MM-DD" />
      </Form.Item>

      <Form.Item name="dataAvailabilityTo" label="Data Availability to">
        <DatePicker format="YYYY-MM-DD" />
      </Form.Item>

      <Form.Item
        name="coverage"
        label="Coverage"
        rules={[{ required: true, message: "Field is required" }]}
      >
        <Input />
      </Form.Item>

      <Form.Item name="initialTimeRun" label="Initial Time Run (prefer UTC)">
        <Input />
      </Form.Item>

      <Form.Item name="timelapseForecast" label="Timelapse forecast">
        <Input />
      </Form.Item>

      <Form.Item name="temporalResolution" label="Temporal Resolution">
        <Input />
      </Form.Item>

      <Form.Item name="horizontalResolution" label="Horizontal Resolution">
        <Input />
      </Form.Item>

      <Form.Item name="aerosolAssimilation" label="Aerosol Assimilation">
        <Input />
      </Form.Item>

      <Form.Item name="meteorologicalFields" label="Meteorological Fields">
        <Input />
      </Form.Item>

      <Form.Item name="description" label="Description">
        <Input />
      </Form.Item>

      <Form.Item
        name="openData"
        label="Open data?"
        rules={[{ required: true, message: "Please make a selection" }]}
      >
        <Radio.Group buttonStyle="solid">
          <Radio.Button value={true}>Yes</Radio.Button>
          <Radio.Button value={false}>No</Radio.Button>
        </Radio.Group>
      </Form.Item>

      <Form.Item name="productView" label="Product View">
        <Input type="url" placeholder="Include 'http://' or 'https://'" />
      </Form.Item>

      <Form.Item name="dataRepository" label="Data Repository">
        <Input type="url" placeholder="Include 'http://' or 'https://'" />
      </Form.Item>

      <Form.Item
        name="sdsEnsembleMember"
        label="SDS Ensemble Member"
        rules={[{ required: true, message: "Field is required" }]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        name="otherAerosolEnsembles"
        label="Other Aerosol Ensembles"
        rules={[{ required: true, message: "Field is required" }]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        name="institution"
        label="Institution"
        rules={[{ required: true, message: "Field is required" }]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        name="institutionURL"
        label="Institution URL"
        rules={[
          { type: "url", message: "Must be a valid URL" },
          { required: true, message: "This field is not optional" },
        ]}
      >
        <Input type="url" placeholder="Include 'http://' or 'https://'" />
      </Form.Item>

      <Form.Item
        name="institution"
        label="Institution"
        rules={[{ required: true, message: "Field is required" }]}
      >
        <Input />
      </Form.Item>

      <Form.Item name="contact" label="Contact Address">
        <Input type="email" placeholder="address@example.com" />
      </Form.Item>
    </Form>
  );
}

function formToEntry(form: FormInstance) {
  const dataAvailabilityFromRaw = form.getFieldValue("dataAvailabilityFrom");
  const dataAvailabilityFrom =
    dataAvailabilityFromRaw === undefined
      ? ""
      : dataAvailabilityFromRaw.format("YYYY-MM-DD");

  let dataAvailabilityTo = null;
  if (!form.getFieldValue("isSatelliteActive")) {
    const dataAvailabilityToRaw = form.getFieldValue("dataAvailabilityTo");
    dataAvailabilityTo =
      dataAvailabilityToRaw === undefined
        ? ""
        : dataAvailabilityToRaw.format("YYYY-MM-DD");
  }

  return { ...form.getFieldsValue(), dataAvailabilityFrom, dataAvailabilityTo };
}

function entryToForm(form: FormInstance, entry: Entry) {
  console.log(entry);
  form.setFieldsValue({
    ...entry,
    dataAvailabilityFrom: moment(entry.dataAvailabilityFrom, "YYYY-MM-DD"),
    dataAvailabilityTo: moment(entry.dataAvailabilityTo, "YYYY-MM-DD"),
  });
}

export const CreateModelModal = makeEntryModal(
  "Create model",
  new TableAPI("models"),
  renderForm,
  formToEntry,
  entryToForm
);
